<template>
  <div class="dropdown">
    <div class="dropdown-menu" v-click-outside-element="closeIfOpen">
      <div class="dropdown-selected" @click="isOpen = !isOpen">
        <b-icon v-if="icon" :icon="icon" />
        <p v-else>{{ title }}</p>
        <b-icon icon="arrow-down" />
      </div>
      <ul class="dropdown-options" v-if="isOpen" @click="isOpen = !isOpen">
        <slot> </slot>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDown',

  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    closeIfOpen() {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
  width: auto;
}

.dropdown-menu {
  position: relative;
  display: block;
  padding: 5px 10px;
  margin: 0 auto;
  outline: none;
  cursor: pointer;
  border: 1px solid #1c2731;
}

.dropdown-options {
  z-index: 10;
}

.dropdown ul {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  list-style: none;
  font-weight: normal;
  border: 1px solid #1c2731;
  border-top: none;
  margin: 0 -1px;
  padding: 0px;
}

.dropdown ul li {
  display: block;
  text-decoration: none;
  color: #9e9e9e;
  padding: 10px 20px;
  transition: background-color 0.25s linear;
}

.dropdown ul li:hover {
  background: #f3f8f8;
}

.dropdown-selected {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dropdown/DropDown.vue